class CurrentShipments extends HTMLElement {
  selectors = {
    emptyShipments: ".empty-shipments",
    loading: "affinity-current-shipments .loading-affinity"
  };

  constructor() {
    super();
    this.init();
  }

  async init () {
    window.openOrderDetails = (orderId) => {
      this.openOrderDetails(orderId);
    };
    window.addEventListener("resize", () => {
      this.handleSize();
    });
    window.closeOrderDetail = (orderId) => {
      this.closeOrderDetail(orderId);
    };

    window.refreshShipments = async () => {
      $(this.selectors.emptyShipments).show();
      $("#shipments-list").empty();
      $(this.selectors.loading).show();
      const responseShipments = await this.getShipments();
      this.initShipmentsComponent(responseShipments);
    };

    const responseShipments = await this.getShipments();
    this.initShipmentsComponent(responseShipments);
  }

  async getShipments() {
    try {
      const session = await recharge.auth.loginCustomerPortal();
      const customer = await recharge.customer.getCustomer(session);
      const customerId = customer.external_customer_id.ecommerce;
      const response = await axios({
        method: "get",
        url: `https://5yc3he6z6b.execute-api.us-east-1.amazonaws.com/staging/api/customers/${customerId}/shipments`
      });

      return response && response.data ? response.data : null;
    } catch (error) {
      console.log("Error", error);
      return null;
    }
  }

  openOrderDetails(orderId) {
    $(`#order-${orderId}`).show();
  }

  // Close the modal for order details
  closeOrderDetail(orderId) {
    $(`#order-${orderId}`).hide();
  }

  getLineItemsStructure(lineItems) {
    let items = "";
    if (lineItems && lineItems.length > 0) {
      lineItems.forEach(item => {
        items += '<div class="product-wrapper flex-column">';
        items += `<span class="tiege-title">${item.title}</span>`;
        if (item.variant_title && item.variant_title != "Default title") {
          items += `<span class="tiege-gray-subtitle">${
            item.variant_title
          }</span>`;
        }
        items += `<span class="tiege-gray-subtitle"> ${item.quantity} × ${
          item.price_set.presentment_money.amount === "0.00"
            ? "FREE"
            : item.price_set.presentment_money.amount +
              " " +
              item.price_set.presentment_money.currency_code
        }</span>`;
        items += "</div>";
      });
    }
    return items;
  }

  getDifferenceInDays(firstDate, secondDate) {
    const msPerDay = 1000 * 60 * 60 * 24;
    const utc1 = Date.UTC(
      firstDate.getFullYear(),
      firstDate.getMonth(),
      firstDate.getDate()
    );
    const utc2 = Date.UTC(
      secondDate.getFullYear(),
      secondDate.getMonth(),
      secondDate.getDate()
    );
    return Math.floor((utc2 - utc1) / msPerDay);
  }

  handleSize() {
    if (window.innerWidth <= 999) {
      $(".view-btn.web").hide();
      $(".view-btn.mobile").show();
    } else {
      $(".view-btn.web").show();
      $(".view-btn.mobile").hide();
    }
  }

  initShipmentsComponent(responseShipments) {
    const green = "#43b02a";
    let shipments = this.filterShipments(
      responseShipments && responseShipments.orders
        ? responseShipments.orders
        : null
    );
    let customerShipmemts = [];
    if (shipments && shipments.length > 0) {
      for (var i = 0; i < shipments.length; i++) {
        const orderSummary = (showViewDetailBtn, shipment) => {
          return (
            '<div class="flex-row justify-content--space-between">' +
            "<div>" +
            `<span class="tiege-title">Order ${
              shipment.name
            } <span class="tiege-subtitle">(${shipment.line_items.length} ${
              shipment.line_items.length > 1 ? "products" : "product"
            })</span></span>` +
            "</div>" +
            `${
              showViewDetailBtn
                ? `<div class="align-items--center"><button class="secondary view-btn web flex align-items--center" onclick="openOrderDetails(${
                    shipment.id
                  })"><svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M8 15.429A7.429 7.429 0 1 0 8 .57 7.429 7.429 0 0 0 8 15.43ZM8 4.571v6.858M4.571 8h6.858" stroke="#43b02a" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path></svg> View Details</button></div>`
                : ""
            }` +
            "</div>" +
            `<span>Tracking: #${
              shipment.fulfillments.length <= 0
                ? "-"
                : shipment.fulfillments[0].tracking_number
            }</span>` +
            '<div class="flex-column shipment-detail">' +
            '<div class="flex-row align-items--center">' +
            `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 19" fill="none" class="icon"><path d="M1 18H0.5C0.5 18.2761 0.723858 18.5 1 18.5V18ZM15.7 18V18.5C15.9761 18.5 16.2 18.2761 16.2 18H15.7ZM15.7 3.29999H16.2C16.2 3.02385 15.9761 2.79999 15.7 2.79999V3.29999ZM1 3.29999V2.79999C0.723858 2.79999 0.5 3.02385 0.5 3.29999H1ZM1 6.60001C0.723858 6.60001 0.5 6.82386 0.5 7.10001C0.5 7.37615 0.723858 7.60001 1 7.60001V6.60001ZM15.7 7.60001C15.9761 7.60001 16.2 7.37615 16.2 7.10001C16.2 6.82386 15.9761 6.60001 15.7 6.60001V7.60001ZM4.10001 1C4.10001 0.723858 3.87615 0.5 3.60001 0.5C3.32386 0.5 3.10001 0.723858 3.10001 1H4.10001ZM3.10001 5.1C3.10001 5.37614 3.32386 5.6 3.60001 5.6C3.87615 5.6 4.10001 5.37614 4.10001 5.1H3.10001ZM13.2 1C13.2 0.723858 12.9761 0.5 12.7 0.5C12.4239 0.5 12.2 0.723858 12.2 1H13.2ZM12.2 5.1C12.2 5.37614 12.4239 5.6 12.7 5.6C12.9761 5.6 13.2 5.37614 13.2 5.1H12.2ZM1 18.5H15.7V17.5H1V18.5ZM16.2 18V3.29999H15.2V18H16.2ZM15.7 2.79999H1V3.79999H15.7V2.79999ZM0.5 3.29999V18H1.5V3.29999H0.5ZM1 7.60001H15.7V6.60001H1V7.60001ZM3.10001 1V5.1H4.10001V1H3.10001ZM12.2 1V5.1H13.2V1H12.2Z" fill="${green}"></path></svg>` +
            '<div class="flex-column">' +
            '<span class="tiege-subtitle">Shipping Date</span>' +
            `<span>${this.formatDeliveryDate(
              shipment.fulfillment_status,
              shipment.fulfillments
            )}</span>` +
            "</div>" +
            "</div>" +
            "</div>" +
            '<div class="flex-column shipment-detail">' +
            '<div class="flex-row align-items--center">' +
            `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 20" fill="none" class="icon"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 6.8C1 3.6 3.5 1 6.7 1C9.8 1 12.4 3.6 12.4 6.8C12.4 10 6.7 19.4 6.7 19.4C6.7 19.4 1 10 1 6.8Z" stroke="${green}" stroke-linecap="round" stroke-linejoin="round"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M8.9 6.6999C8.9 7.9999 7.9 8.9999 6.7 8.9999C5.5 8.9999 4.5 7.9999 4.5 6.6999C4.5 5.3999 5.5 4.3999 6.7 4.3999C7.9 4.3999 8.9 5.3999 8.9 6.6999V6.6999Z" stroke="${green}" stroke-linecap="round"></path></svg>` +
            '<div class="flex-column">' +
            '<span class="tiege-subtitle">Delivery Address</span>' +
            `<span>${window.formatSimpleAddress(shipment.shipping_address).replace('\n', '<br>')}</span>` +
            "</div>" +
            "</div>" +
            "</div>" +
            '<div class="flex-row total-wrapper">' +
            "<span>Order Total</span>" +
            `<span>${shipment.total_price_set.presentment_money.amount} ${
              shipment.total_price_set.presentment_money.currency_code
            }</span>` +
            "</div>" +
            `${
              showViewDetailBtn
                ? `<div><button class="secondary view-btn mobile" onclick="openOrderDetails(${
                    shipment.id
                  })"><svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M8 15.429A7.429 7.429 0 1 0 8 .57 7.429 7.429 0 0 0 8 15.43ZM8 4.571v6.858M4.571 8h6.858" stroke="#58a4b0" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path></svg> View Details</button></div>`
                : ""
            }`
          );
        };

        if (shipments[i].line_items.length > 1 || (shipments[i].line_items.length === 1  && !shipments[i].line_items[0].sku.startsWith('GIFT-CARD'))) {
          customerShipmemts.push(
          `<div class="shipmet-wrapper wrapper">${orderSummary(
            true,
            shipments[i]
          )}</div>` +
            `<div id="order-${
              shipments[i].id
            }" class="modal-affinity dialog baseline" style="display: none;">` +
            '<div class="modal-content">' +
            `<button onclick="closeOrderDetail(${
              shipments[i].id
            })" class="back-btn-wrapper">` +
            '<span class="svg-wrapper"><svg viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M8.5 1L1.5 8L8.5 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>' +
            "<span>Back</span>" +
            "</button>" +
            `<div class="shipmet-wrapper wrapper">${orderSummary(
              false,
              shipments[i]
            )}</div>` +
            '<div class="order-details-wrapper wrapper">' +
            `<div>${this.getLineItemsStructure(shipments[i].line_items)}</div>` +
            '<div class="flex-column price-summary">' +
            `<span class="flex-row justify-content--space-between"><span>Subtotal</span><span>${shipments[i].subtotal_price_set.presentment_money.amount} ${shipments[i].subtotal_price_set.presentment_money.currency_code}</span></span>` +
            `<span class="flex-row justify-content--space-between"><span>Taxes</span><span>${shipments[i].total_tax_set.presentment_money.amount} ${shipments[i].total_tax_set.presentment_money.currency_code}</span></span>` +
            (shipments[i].shipping_lines && shipments[i].shipping_lines.length > 0 ? `<span class="flex-row justify-content--space-between"><span>Shipping: ${shipments[i].shipping_lines[0].code}</span><span>${shipments[i].shipping_lines[0].price_set.presentment_money.amount} ${shipments[i].shipping_lines[0].price_set.presentment_money.currency_code}</span></span>` : '') +
            `<span class="flex-row justify-content--space-between total-wrapper tiege-title"><span>Order Total</span><span>${shipments[i].total_price_set.presentment_money.amount} ${shipments[i].total_price_set.presentment_money.currency_code}</span></span>` +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>"
          );
        }
      }
      $("#shipments-list").empty();
      $(this.selectors.loading).hide();
      $("#shipments-list").append(customerShipmemts.join("\n"));
      $('affinity-current-shipments').show();
    } else {
      $(this.selectors.loading).hide();
      $('affinity-current-shipments').hide();
    }
    this.handleSize();
  }

  // Format date for current shipment
  formatDeliveryDate(fulfillmentStatus, fulfillments) {
    if (fulfillmentStatus === null) {
      return "Processing...";
    }

    const delivered = fulfillments.find(f => f.shipment_status === "delivered");
    if (delivered !== undefined) {
      const date = moment(delivered.updated_at).format("MMMM DD, YYYY");
      return `Delivered on ${date}`;
    }
    return moment(fulfillments[0].created_at).format("MMMM DD, YYYY");
  }

  // Filter from Shopify orders the ones to display in the current shipments section
  filterShipments(shipments) {
    if (shipments && shipments.length > 0) {
      return shipments.filter(shipment => {
        // Not shipped orders
        if (shipment.fulfillment_status === null) {
          return true;
        }

        if (shipment.fulfillment_status === "fulfilled") {
          // Check if delivered
          const delivered = shipment.fulfillments.find(
            f => f.shipment_status === "delivered"
          );
          const today = new Date();

          if (delivered !== undefined) {
            // Check delivered in the configured threshold
            const deliveryDate = new Date(delivered.updated_at);
            return (
              this.getDifferenceInDays(deliveryDate, today) <=
              window.TIEGE.affinity.shipment_threshold
            );
          }

          const createdDate = new Date(shipment.created_at);
          return this.getDifferenceInDays(createdDate, today) <= 21;
        }
        return false;
      });
    }
    return null;
  }
}

customElements.define("affinity-current-shipments", CurrentShipments);